<script>
    import FancyButton from './FancyButton.svelte';
</script>


<FancyButton label="Play as the CEO" image={"/ceo.svg"}/>